import { Component, Input } from '@angular/core';

export interface Incident {
  partnerName: string;
  partnerCode: string;
  status: 'Active' | 'Down' | 'Slow';
  modifiedDate: string;
  description: string;
  isActive: '1' | '0';
  userEmail: string;
  notificationStatus: number;
  emailAddressCc: string;
  sendPartnerCode: string;
  sendPartnerName: string;
}
@Component({
  selector: 'papi-incident',
  templateUrl: './incident.component.html',
})
export class IncidentComponent {
  @Input() incident: Incident;
}
